var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-flex container-wrapper"},[_c('Sidebar'),_c('div',{staticClass:"v-flex"},[(_vm.$store.getters.isLegacyUser)?_c('LegacyNavBar'):_c('Navbar'),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }